import HeroBanner from "../components/HeroBanner";
import ServicesSection from "../components/ServicesSection";
import AboutSection from "../components/AboutSection";
import ProgressTrackerSection from "../components/ProgressTrackerSection";
import TrustSectiion from "../components/TrustSectiion";
import WhyChooseUs from "../components/WhyChooseUs";
import useAppData from "../hooks/useAppData";
import { Helmet } from "react-helmet-async";

export default function Home() {
	const { homePage } = useAppData();
	return (
		<>
			<Helmet>
				<title>{homePage.meta_title}</title>
				<meta name="description" content={homePage.meta_description} />
				<meta name="keywords" content={homePage.meta_keywords} />
			</Helmet>
			<HeroBanner />
			<ServicesSection />
			<hr />
			<AboutSection />
			<hr />
			<WhyChooseUs />
			<ProgressTrackerSection />
			<div style={{ backgroundColor: "#dfdfdf" }}>
				<TrustSectiion />
			</div>
		</>
	);
}
